var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credits"},[_c('div',{staticClass:"credits__intro"},[_vm._v(_vm._s(_vm.label))]),_c('img',{attrs:{"src":(_vm.$baseUrl + "images/LogoTerna.svg"),"alt":"logo di Terna"}})])}
var staticRenderFns = []

export { render, staticRenderFns }